document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-size-guide-unit]');
  if (!button) return;

  const guide = button.closest('[data-garment-guide]');
  if (!guide) return;

  const unit = button.dataset.sizeGuideUnit;
  guide.querySelectorAll('[data-size-guide-unit]').forEach((control) => {
    control.setAttribute('aria-pressed', String(control === button));
  });

  guide.querySelectorAll('[data-inches][data-centimeters]').forEach((value) => {
    value.textContent = unit === 'centimeters' ? value.dataset.centimeters : value.dataset.inches;
  });
});
